import React, { useState } from "react";
import Hero from "../Hero/Hero";
import ValueProps from "../ValueProps/ValueProps";
import Categories from "../Categories/Categories";
import Partners from "../Partners/Partners";
import Services from "../Services/Services";
import HowItWorks from "../HowItWorks/HowItWorks";
import FAQ from "../FAQ/FAQ";
import Franchise from "../Franchise/Franchise";
import DownloadApp from "../DownloadApp/DownloadApp";
import PopularProducts from "../PopularProducts/PopularProducts";

const Battery_product = () => {
  const [cartCount, setCartCount] = useState(0);
  const handleAddToCart = () => {
    setCartCount((prev) => prev + 1);
  };
  return (
    <div>
      <main className="mainContent">
        <Hero code="BATTERY" />
        <ValueProps />
        <Categories code="BATTERY" />
        <Partners code="BATTERY" />
        <PopularProducts code="BATTERY" entityType="POPULAR" />
        <Services />
        <HowItWorks />
        <FAQ />
        <Franchise />
        <DownloadApp />
      </main>
    </div>
  );
};

export default Battery_product;
